import React from "react"
import { Link, graphql } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm, scale } from "../utils/typography"
import Image from "gatsby-image"
import styled from "styled-components"
import Disqus from "gatsby-plugin-disqus"

const StyledDate = styled.p`
  ${scale(-1 / 5)};
  display: block;
  margin-bottom: ${rhythm(1)};
  margin-top: ${rhythm(-1)};
`

const StyledImage = styled(Image)`
  margin-bottom: ${rhythm(1)};
`

const StyledHr = styled.hr`
  margin-bottom: ${rhythm(1)};
`

const StyledArticleList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  list-style: none;
  flex-direction: column;
  padding: 0;

  & li:last-of-type {
    text-align: right;
  }
`

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteUrl = this.props.data.site.siteMetadata.siteUrl
    const { previous, next } = this.props.pageContext

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
          image={post.frontmatter.socialImage.childImageSharp.fixed.src}
        />
        <h1>{post.frontmatter.title}</h1>
        <StyledDate>{post.frontmatter.date}</StyledDate>
        {post.frontmatter.image ? (
          <StyledImage
            alt={post.frontmatter.title}
            fluid={post.frontmatter.image.childImageSharp.fluid}
          />
        ) : null}
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
        <StyledHr
          style={{
            marginBottom: rhythm(1),
          }}
        />
        <Bio />

        <Disqus
          identifier={post.id}
          title={post.frontmatter.title}
          url={`${siteUrl}${this.props.location.pathname}`}
        />

        <StyledArticleList>
          <li key="0">
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li key="1">
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </StyledArticleList>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
        siteUrl
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        socialImage {
          childImageSharp {
            fixed(width: 876) {
              src
            }
          }
        }
        image {
          childImageSharp {
            fluid(maxWidth: 666) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
